export interface ITaiKhoan{
    Id: number,
    TaiKhoan: string,
    HoTen: string,
    NgaySinh: string,
    Cmnd: string,
    DienThoai: string,
    Email: string,
    DangNhapLanCuoi: string,
    TenCoQuan: string,
    TenDonVi: string,
    TenChucVu: string,
    Avatar:string,
    SMS:boolean,
    Ids: string;
}
export class TaiKhoan implements ITaiKhoan{
    Id: number =0;
    TaiKhoan: string="";
    HoTen: string="";
    NgaySinh: string="";
    Cmnd: string="";
    DienThoai: string="";
    Email: string="";
    DangNhapLanCuoi: string="";
    TenCoQuan: string="";
    TenDonVi: string="";
    TenChucVu: string="";
    Avatar:string="none";
    SMS:boolean=true;
    Ids: string = "";
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/thong-tin-tai-khoan/tai-khoan.ts